import { render, staticRenderFns } from "./Runningwater.vue?vue&type=template&id=0188c006&scoped=true"
import script from "./Runningwater.vue?vue&type=script&lang=js"
export * from "./Runningwater.vue?vue&type=script&lang=js"
import style0 from "./Runningwater.vue?vue&type=style&index=0&id=0188c006&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0188c006",
  null
  
)

export default component.exports